import React from "react";
import "./Container.scss";
import { IBlockElement } from "../../../types/IBlockElement";

export default function Container({ id, className, children, onClick }: IBlockElement) {
    return <div id={id} className={className} onClick={onClick}>{children}</div>;
}